// PCRBadges.jsx
import React, { useEffect, useRef } from 'react';

const normalize = (s) => (s || '').toLowerCase().trim();
const RANK = ['highly recommend', 'recommend', 'consider', 'pass'];

const ctx = (r) => {
  switch (normalize(r)) {
    case 'highly recommend': return 'primary';   // blue pill for HR
    case 'recommend':        return 'success';   // green
    case 'consider':         return 'warning';   // amber
    case 'pass':             return 'secondary'; // grey
    default:                 return 'dark';
  }
};

const short = (item) => item?.short
  ?? (normalize(item?.rating) === 'highly recommend' ? 'HR'
    : normalize(item?.rating) === 'recommend' ? 'R'
    : normalize(item?.rating) === 'consider' ? 'C'
    : normalize(item?.rating) === 'pass' ? 'P' : '?');

export function PCRBadges({ ratings, showLatest = true }) {
  const root = useRef(null);

  // Enable Bootstrap tooltips once mounted
  useEffect(() => {
    if (!root.current || !window.bootstrap) return;
    const els = root.current.querySelectorAll('[data-bs-toggle="tooltip"]');
    const instances = [...els].map(el => new window.bootstrap.Tooltip(el));
    return () => instances.forEach(i => i.dispose());
  }, []);

  if (!Array.isArray(ratings) || ratings.length === 0) {
    return <span className="text-muted">—</span>;
  }

  const sorted = [...ratings].sort((a, b) =>
    (RANK.indexOf(normalize(a?.rating)) ?? 999) -
    (RANK.indexOf(normalize(b?.rating)) ?? 999)
  );

  return (
    <div ref={root} className="pcr-badges d-flex align-items-center gap-2 flex-wrap">
      {sorted.map((r, i) => {
        const label = r.rating?.replace(/\b\w/g, m => m.toUpperCase());
        const tip = `
          <div class="text-start">
            <div class="fw-semibold mb-1">${r.model ?? 'Model'} — ${label ?? ''}</div>
            <div class="small">${(r.summary ?? '').replace(/"/g, '&quot;')}</div>
          </div>
        `;
        return (
          <span
            key={`${r.model ?? 'm'}-${i}`}
            className={`badge rounded-pill text-bg-${ctx(r.rating)} pcr-badge`}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-html="true"
            title={tip}
          >
            {short(r)}
          </span>
        );
      })}
    </div>
  );
}
